// @ts-nocheck
import { EagerLoadingLogoProvider } from "@insite/client-framework/Common/EagerLoadingLogo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import dismissRfqUpdates from "@insite/client-framework/Store/Context/Handlers/DismissRfqUpdates";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import SkipNav, { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link from "@insite/mobius/Link";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import Typography from "@insite/mobius/Typography";
// import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries"; // Foundation
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// import React, { useEffect } from "react"; // Foundation
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Starter Custom Code - End */

// Store Custom Code
import * as cssLinter from "css";

// Foundation --->
import loadCurrentAccount from "@insite/client-framework/Store/Data/Accounts/Handlers/LoadCurrentAccount";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Hidden from "@insite/mobius/Hidden";
import { HiddenProps } from "@insite/mobius/Hidden/Hidden";
import { getProp } from "@insite/mobius/utilities";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import constants from "@store/constants";
import zoneElementsSelector from "@store/Framework/Common/Utilities/zoneElementsSelector";
import useHeaderHeight from "@store/Framework/Store/Bunzl/Components/Header/Hooks/useHeaderHeight";
import useIsHeaderFixed from "@store/Framework/Store/Bunzl/Components/Header/Hooks/useIsHeaderFixed";
import useDynamicSearchWidth from "@store/Framework/Store/Bunzl/Pages/Header/useDynamicSearchWidth";
import { useIsAuthenticated } from "@store/Framework/Store/Foundation/Context/ContextHooks";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import shadows from "@store/Themes/common/styleguide/config/shadows";
import useIsomorphicLayoutEffect from "@toolkit/Framework/Common/Hooks/useIsomorphicLayoutEffect";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import React, { useEffect, useRef } from "react";

// Store Custom Code - >
const enum fields {
    isHeaderFixedOption = "isHeaderFixedOption",
    customCSS = "customCSS",
    shadow = "shadow",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.isHeaderFixedOption]: boolean;
        [fields.customCSS]: string;
        [fields.shadow]: string;
    };
}

// <--- bunzl custom code

const mapStateToProps = (state: ApplicationState) => ({
    siteName: state.context.website.name,
    session: getSession(state),
    myAccountPageUrl: getPageLinkByPageType(state, "MyAccountPage")?.url,
});

const mapDispatchToProps = {
    dismissRfqUpdates,
    // Foundation
    loadCurrentAccount,
};

type Props = PageProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasToasterContext &
    HasHistory &
    // Foundation
    OwnProps;

export interface HeaderStyles {
    page?: MobiusPageProps;
    container?: InjectableCss;
    skipToContent?: SkipNavStyles;
    websiteName?: InjectableCss;
    // Starter Custom Code
    wrapper?: InjectableCss;
    contentWrapper?: InjectableCss;
    navWrapper?: InjectableCss;
    bottomContentWrapper?: InjectableCss;
    printWrapper?: InjectableCss;
    // Foundation
    logoWrapper?: InjectableCss;
    navigationWrapper?: InjectableCss;
    secondaryNavigationWrapper?: InjectableCss;
    searchNavigationWrapper?: InjectableCss;
    loginCart?: InjectableCss;
    mainNavigation?: HiddenProps;
    search?: InjectableCss;
}

// Foundation --->
const secondaryNavigationWrapperSpacing = 10; // Store Custom Code
const searchNavigationWrapperSpacing = 12;

const navigationsContainer = {
    css: css`
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        ${siteWidthStyles()}
        background-color: ${getColor("common.background")};
    `,
};
// <--- Foundation

export const headerStyles: HeaderStyles = {
    skipToContent: {
        skipToContent: {
            variant: "primary",
            css: css`
                margin: 0;
                position: absolute;
                clip: rect(0, 0, 0, 0);
                &:focus {
                    clip: unset;
                    z-index: 1000;
                }
            `,
        },
    },
    page: {
        fullWidth: [true, true, true, true, true], // Foundation
        css: css`
            position: relative;
            overflow: visible !important; /* Required to override overflow from Mobius Page Component */
        `,
    },
    container: {
        css: css`
            background-color: ${getColor("secondary.main")};
            display: flex;
            > div:first-child {
                flex-grow: 1;
            }
            > div:last-child {
                max-width: 150px;
                display: flex;
                align-items: center;
                justify-content: center;
                height: auto;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                max-width: 100px;
                            `,
                        ],
                        "max",
                    )}
            }
        `,
    },
    websiteName: {
        css: css`
            @media print {
                display: block;
            }
            font-size: ${pxToRem(12)};
            padding-left: ${pxToRem(15)};
            display: none;
        `,
    },
    logoWrapper: {
        css: css`
            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        css`
                            margin: 0 1.5em 0 1.25em;
                        `,
                        null,
                        css`
                            margin: ${pxToRem(0, 20, 0, 0)};
                        `,
                        css`
                            margin: ${pxToRem(0, 60, 0, 0)}; /* Store Custom Code */
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    navigationWrapper: {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: column;
        `,
    },
    secondaryNavigationWrapper: {
        css: css`
            ${navigationsContainer.css}
            background-color: ${getColor("common.shadesLight")}; /* Store Custom Code */
            padding: ${pxToRem(secondaryNavigationWrapperSpacing, 0)};
            font-size: ${({ theme }) => theme.design.typography.size.smaller};
            justify-content: flex-end;
            line-height: ${({ theme }) => theme.design.typography.lineHeight.smaller};

            > * {
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }
        `,
    },
    searchNavigationWrapper: {
        css: css`
            ${navigationsContainer.css}
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding-top: ${pxToRem(searchNavigationWrapperSpacing - secondaryNavigationWrapperSpacing)};
            padding-bottom: ${pxToRem(searchNavigationWrapperSpacing)};
            color: ${getColor("primary")};
        `,
    },
    mainNavigation: {
        css: css`
            /* Bunzl Custom Code */
            align-items: flex-end;

            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        css`
                            ${contentSpacingStyles(0, pxToRem(15), 0)}
                        `,
                        null,
                        css`
                            ${contentSpacingStyles(0, pxToRem(15), 0)}
                        `,
                        css`
                            ${contentSpacingStyles(0, pxToRem(20), 0)}
                        `,
                        css`
                            ${contentSpacingStyles(0, pxToRem(35), 0)}
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    search: {
        css: css`
            flex-grow: 1;

            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        null,
                        null,
                        css`
                            ${contentSpacingStyles(0, pxToRem(5), 0, pxToRem(5))}
                        `,
                        css`
                            /* Bunzl Custom Code */
                            ${contentSpacingStyles(0, pxToRem(10), 0, pxToRem(10))}
                        `,
                        css`
                            ${contentSpacingStyles(0, pxToRem(15), 0, pxToRem(15))}
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    loginCart: {
        css: css`
            /* Bunzl Custom Code - Start */
            > div {
                display: flex;
                align-items: flex-end;
            }
            /* Bunzl Custom Code - End */
            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        css`
                            ${contentSpacingStyles(0, 0, 0, pxToRem(10))}

                            ${zoneElementsSelector} {
                                ${contentSpacingStyles(0, pxToRem(15), 0)}
                            }
                        `,
                        css`
                            ${contentSpacingStyles(0, 0, 0, pxToRem(15))}
                        `,
                        css`
                            ${contentSpacingStyles(0, 0, 0, pxToRem(5))}
                            ${zoneElementsSelector} {
                                ${contentSpacingStyles(0, 0, 0, pxToRem(5))}
                            }
                        `,
                        css`
                            /* Bunzl Custom Code - Start */
                            ${contentSpacingStyles(0, 0, 0, pxToRem(20))}

                            ${zoneElementsSelector} {
                                ${contentSpacingStyles(0, pxToRem(20), 0)}
                            }
                            /* Bunzl Custom Code - End */
                        `,
                        css`
                            ${contentSpacingStyles(0, 0, 0, pxToRem(35))}

                            ${zoneElementsSelector} {
                                ${contentSpacingStyles(0, pxToRem(35), 0)}
                            }
                        `,
                    ],
                    mediaOptions.min,
                )}

            ${zoneElementsSelector} {
                vertical-align: middle;
            }
        `,
    },
};

const styles = headerStyles;

const Header = ({
    id,
    siteName,
    session,
    toaster,
    history,
    myAccountPageUrl,
    dismissRfqUpdates,
    // Foundation
    loadCurrentAccount,
    // Store Custom Code
    fields: { isHeaderFixedOption, customCSS, shadow },
}: Props) => {
    // Store --->
    const mainRef = useRef<HTMLDivElement>(null);
    const secondaryRef = useRef<HTMLDivElement>(null);
    const TabbedNavigationRef = useRef<HTMLDivElement>(null);
    const mainNavigationRef = useRef<HTMLDivElement>(null);
    const { setIsHeaderFixed } = useIsHeaderFixed();
    const { setHeaderHeight, headerHeight } = useHeaderHeight();
    // <--- Store

    // Store Custom Code - >
    const logoRef = useRef<HTMLDivElement>(null);
    useDynamicSearchWidth(mainRef, logoRef);
    // <--- Bunzl Custom Code

    const viewMyDashboardClickHandler = () => {
        if (myAccountPageUrl) {
            history.push(myAccountPageUrl);
        }
    };
    // Foundation --->
    const isAuthenticated = useIsAuthenticated();

    useEffect(() => {
        if (mainRef.current) {
            const mainContainerHeight =
                mainRef.current?.getBoundingClientRect().height || constants.defaultHeaderHeight.mainHeight;
            const secondaryContainerHeight =
                secondaryRef.current?.getBoundingClientRect().height || constants.defaultHeaderHeight.secondaryHeight;
            const tabbedNavigationHeight = TabbedNavigationRef.current?.getBoundingClientRect().height || 0;
            if (
                mainContainerHeight !== headerHeight.mainHeight ||
                secondaryContainerHeight !== headerHeight.secondaryHeight ||
                tabbedNavigationHeight !== headerHeight.tabbedNavigationHeight
            ) {
                setHeaderHeight({
                    mainHeight: mainContainerHeight,
                    secondaryHeight: secondaryContainerHeight,
                    tabbedNavigationHeight,
                });
            }
        }
        // Store Custom Code - useEffect dependency array was incorrect as the base ref object is a stable reference so it was only firing on first render before there was a height to measure
    }, [mainRef.current, secondaryRef.current]);

    useEffect(() => {
        setIsHeaderFixed(isHeaderFixedOption);
    }, [isHeaderFixedOption]);

    useEffect(() => {
        if (isAuthenticated) {
            loadCurrentAccount();
        }
    }, [isAuthenticated]);
    // <--- Foundation

    useEffect(() => {
        if (session.hasRfqUpdates && myAccountPageUrl) {
            toaster.addToast({
                body: (
                    <>
                        <Typography>{translate("You have new quote information.")}</Typography>
                        <Link onClick={viewMyDashboardClickHandler}>{translate("View My Dashboard")}</Link>
                    </>
                ),
                messageType: "info",
                timeoutLength: 1000 * 60 * 60 * 24 * 365,
                onClose: () => {
                    dismissRfqUpdates();
                },
            });
        }
    }, [myAccountPageUrl]);

    // Foundation --->
    const pageStyles: MobiusPageProps = {
        ...styles.page,
        css: css`
            ${styles?.page?.css}
            /* Bunzl Custom Code */            
            ${shadow && `box-shadow: ${shadow}`};
            ${isHeaderFixedOption
                ? css`
                      ${breakpoint("md")} {
                          position: fixed !important;

                          top: 0;
                          left: 0;
                          right: 0;
                      }
                  `
                : css`
                      ${breakpoint("md")} {
                          position: relative !important;
                      }
                  `}
            z-index: ${getProp("theme.zIndex.menu")};

            &:hover,
            :focus,
            :active {
                background-color: ${getColor("common.background")};
            }
        `,
    };

    const containerStyles: InjectableCss = {
        css: css`
            position: relative !important;
            top: 0;
            left: 0;
            right: 0;
            background-color: ${getColor("common.background")};
        `,
    };

    const secondaryContainerStyles: InjectableCss = {
        css: css`
            background-color: ${getColor("common.shadesLight")}; /* Store Custom Code */
        `,
    };
    // Store Custom Code - removed dynamic header height
    const searchNavigationWrapperStyles: InjectableCss = {
        ...styles.searchNavigationWrapper?.css,
        css: css`
            ${styles.searchNavigationWrapper?.css}
            padding-top: 0;
            padding-bottom: 0;
            padding-block: ${pxToRem(16)};
            position: relative;
        `,
    };
    // <--- Foundation

    // Store Custom Code
    const customCssWrapper = {
        css: css`
            ${customCSS}
        `,
    };
    const afterHeader = React.createRef<HTMLSpanElement>();
    /* Store Custom Code - added customCssWrapper and classnames Start */
    return (
        <>
            {siteName && <Typography {...styles.websiteName}>{siteName}</Typography>}
            <StyledWrapper {...customCssWrapper}>
                <Page className="header-wrapper" isHeader {...pageStyles}>
                    <SkipNav
                        extendedStyles={styles.skipToContent}
                        text={translate("Skip to main content")}
                        destination={afterHeader}
                    />
                    {/* Foundation ---> */}
                    <StyledWrapper ref={secondaryRef} {...secondaryContainerStyles} className="header-secondary">
                        <Hidden below="md">
                            <StyledWrapper {...styles.secondaryNavigationWrapper}>
                                <Zone contentId={id} zoneName="SecondaryNavigation" />
                            </StyledWrapper>
                        </Hidden>
                    </StyledWrapper>
                    <StyledWrapper {...containerStyles} ref={mainNavigationRef} className="header-main">
                        <StyledWrapper {...styles.navigationWrapper}>
                            <StyledWrapper ref={mainRef} {...searchNavigationWrapperStyles}>
                                <Hidden above="sm">
                                    <StyledWrapper {...styles.mainNavigation} className="header-mobile-navigation">
                                        <Zone contentId={id} zoneName="MainNavigation" />
                                    </StyledWrapper>
                                </Hidden>
                                {/* Store Custom Code */}
                                <StyledWrapper ref={logoRef} {...styles.logoWrapper} className="header-logo">
                                    <Zone contentId={id} zoneName="Logo" />
                                </StyledWrapper>
                                <Hidden below="md" {...styles.mainNavigation} className="header-navigation">
                                    <Zone contentId={id} zoneName="MainNavigation" />
                                </Hidden>
                                <StyledWrapper {...styles.search} className="header-search">
                                    <Zone contentId={id} zoneName="Search" />
                                </StyledWrapper>
                                <StyledWrapper {...styles.loginCart} className="header-login-cart">
                                    <Zone contentId={id} zoneName="LoginAndCart" />
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                    <Hidden below="md">
                        <StyledWrapper ref={TabbedNavigationRef}>
                            <Zone contentId={id} zoneName="TabbedNavigation" />
                        </StyledWrapper>
                    </Hidden>
                    {/* <--- Foundation */}
                    <span ref={afterHeader} tabIndex={-1} />
                </Page>
            </StyledWrapper>
        </>
    );
    /* Store Custom Code - added customCssWrapper and classnames - End */
};

/* Store Custom Code - Start */
const defaultCustomCss = `.header-wrapper {
}
.header-secondary {
}
.header-main {
}
.header-logo {
}
.header-navigation {
}
.header-search {
}
.header-login-cart {
}
.header-mobile-navigation {
}

`;
const themeShadowOptions = shadows ? Object.entries(shadows).map(([key, value]) => ({ value, displayName: key })) : [];
/* Store Custom Code - End */
const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withToaster(withHistory(Header))),
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
        // Foundation -->
        fieldDefinitions: [
            {
                name: fields.isHeaderFixedOption,
                displayName: "Make Header Fixed When Scrolling",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            // <-- Foundation
            /* Store Custom Code - Start */
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,

                tab: {
                    displayName: "Advanced",
                    sortOrder: 2,
                },
                validate: value => {
                    if (!value) return "";
                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }
                    return "Unable to parse CSS";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
            {
                name: fields.shadow,
                displayName: "Shadow",
                editorTemplate: "DropDownField",
                fieldType: "General",
                options: themeShadowOptions,
                defaultValue: "none",
            },
            /* Store Custom Code - End */
        ],
    },
};

export const HeaderContext = "HeaderContext";

export default pageModule;
